/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import loader from '../../../../../../../assets/img/icons/TizetiLoaderColored.gif';
// import { TowersProps } from '../types/TowersProps';
import GeniatechContext from '../../../../../../../context/GeniatechContext';

const TowerTable = () => {
  const { loading, fetched, searchData } = useContext(GeniatechContext);
  const tableData =
    fetched && fetched.length
      ? fetched.map((row, i) => (
          <tr
            className="text-nowrap"
            style={{ cursor: 'pointer' }}
            key={i + 1}
            onClick={() => {
              searchData(row.name);
            }}
          >
            <td>{i + 1}</td>
            <td>{row.id}</td>
            <td>
              {/* <Link to={`${PATHS.NOC_CNMAESTRO_TOWERS_INFORMATION}/${information}`} target="_blank"> */}
              {row.name}
              {/* </Link> */}
            </td>
            <td>{row.network}</td>
            <td>{row.location.type}</td>
            <td>{row.location.coordinates}</td>
            <td>{row.managed_account}</td>
          </tr>
        ))
      : 'no alarm';
  return (
    <div className="card x-panel mt-2 px-0">
      <div className="table-responsive content col-12 px-1">
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Tower ID</th>
              <th className="text-nowrap">Name</th>
              <th>Network</th>
              <th>Location Type</th>
              <th>Location Coordinates</th>
              <th>Managed Account</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <img src={loader} alt="loading gif" />
              </tr>
            ) : (
              tableData
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TowerTable;
